// extracted by mini-css-extract-plugin
export var activeDot = "_4g-c";
export var buttonContainer = "_4g-9";
export var channelButton = "_4g-a";
export var clickable = "_4g-d";
export var content = "_4g-0";
export var contentFull = "_4g-2";
export var contentThird = "_4g-1";
export var contentWrapper = "_4g-7";
export var description = "_4g-5";
export var heightShort = "_4g-f";
export var image = "_4g-3";
export var imageContainer = "_4g-4";
export var selectButton = "_4g-e";
export var spinnerContainer = "_4g-b";
export var titleContent = "_4g-8";
export var titleWrapper = "_4g-6";